<script lang="ts">
  import type { ILayoutOptions } from "src/ts/Interfaces";
  import {
    Button,
    Column,
    Grid,
    ImageLoader,
    Modal,
    RadioTile,
    Row,
    TileGroup,
  } from "carbon-components-svelte";
  import { assetsURI, layoutId, optionsData } from "./../../ts/Stores";
  import { Template } from "carbon-icons-svelte";

  let open: boolean = false;

  let apiuri: string = null;
  assetsURI.subscribe((value) => {
    apiuri = value;
  });

  let layoutOptions: ILayoutOptions = null;
  optionsData.subscribe((value) => {
    layoutOptions = value.layoutOptions;
  });

  let selectedLayoutId: string = null;
  layoutId.subscribe((value) => {
    selectedLayoutId = value;
  });
</script>

{#if layoutOptions.layouts.length > 1}
  <Button kind="secondary" on:click={() => (open = true)} icon={Template}>
    Starter Templates
  </Button>

  <Modal
    bind:open
    modalHeading="Starter Templates"
    primaryButtonText="Confirm"
    secondaryButtonText="Cancel"
    on:click:button--secondary={() => (open = false)}
    on:submit={() => {
      layoutId.set(selectedLayoutId);
      open = false;
    }}
  >
    <!-- todo: the below if condition causes request to the images each time the modal is opened. if removed, on submit, the entire wizard duplicates! -->
    {#if open}
      <TileGroup
        legend="Select one of the listed templates"
        bind:selected={selectedLayoutId}
        class="flex-wrap"
      >
        {#each layoutOptions.layouts as layout}
          <RadioTile value={layout.id}>
            <ImageLoader src="{apiuri}/images/layouts/{layout.previewImage}" />
            {layout.name}
          </RadioTile>
        {/each}
      </TileGroup>
    {/if}
  </Modal>
{/if}
